import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=eedc85be"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"
import style0 from "./Point.vue?vue&type=style&index=0&id=eedc85be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports